import $ from "jquery";
import { Klass, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
 * VuwFileThumbnail for VuwFileField
 * @options
 * - @required {string} dataType
 */
vuwer.appendKlass("VuwFileThumbnail", {
	_initialize(opt) {
		const _super_ = Klass("VuwFileThumbnail").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		if(!this.dataType) {
			csl.warn.red(`${this.getAddress()}._initialize() ... no dataType.`);
			return false;
		}
		
		return this;
	},
	
	render($elm, state) {
		if(state.src) {
			let fileType = this.dataType;
			let { src } = state;
			if( (/^data:/).test(src) ) {
				// onFileRead
				if(fileType === "mix") {
					const mime = src.split(";").shift().replace(/^data:/, "");
					const arr = mime.split("/");
					fileType = (["text", "application"].indexOf(arr[0]) < 0) ? arr.shift() : arr.pop();
					(fileType === "image") && (fileType = "img");
				}
				
			} else {
				// onUpload | setVal
				src += `?_=${( new Date() ).valueOf()}`;
			}
			
			switch(fileType) {
				case "img": {
					state.attr = {
						src,
						alt: "thumbnail"
					};
					break;
				}
				
				case "video": {
					state.attr = {
						src,
						preload: "metadata",
						controls: "controls"
					};
					break;
				}
			}
			
			if(state.attr) {
				$elm = $(`<${fileType}/>`).attr(state.attr);
				delete state.attr;
				
			} else {
				$elm = $("<a/>").attr({
					href: src,
					target: "_blank"
				}).append( $("<span/>").text(state.fname || "登録済みのファイル") );
			}
			delete state.src;
			
		} else {
			$elm = $("<span/>").text(state.fname || "ファイルが選択されていません");
		}
		
		return $elm;
	}
});
